// extracted by mini-css-extract-plugin
export default {"card":"CardAd_card__lvl+H","card-vip":"CardAd_card-vip__NSJH0"};